module.exports = __webpack_public_path__ + "src/app/_content/imgs/bmw/blackoil/black mini oil image.png?84f7b7969c657d48670e432b910d5af6";